import { countriesFromLocale } from "../../utils/countries"

export const DND_STREAM_RULE = "STREAM_RULE";
export const DND_STREAM_RULE_LINE = "STREAM_RULE_LINE";

export const getCountries = (language) => countriesFromLocale(language);

export const dropdownKeys = {
    destination: 'destination'
}

export const conditionKeys = [
    'colli',
    'weight',
    'length',
    'width',
    'height',
    'volume',
    'time'
]

export const streamRuleLineKeys = [
    ...conditionKeys,
    ...Object.values(dropdownKeys),
]

export const getStreamRuleKey = (key) => {
    if(streamRuleLineKeys.includes(key)) {
        return key;
    }
    return "choose_key";
}

export const conditions = (key) => {
    if(conditionKeys.includes(key)) {
        return [
            'greaterthan',
            'smallerthan',
            'equalto',
            'notequalto',
            'greaterthanorequalto',
            'smallerthanorequalto',
        ]
    }
    return ['equalto','notequalto'];
}

export const getMobileCondition = (condition) => {
    switch(condition) {
        case "greaterthan" : return ">";
        case "smallerthan" : return "<";
        case "equalto" : return "=";
        case "notequalto" : return "!=";
        case "greaterthanorequalto" : return ">=";
        case "smallerthanorequalto" : return "<=";
    }
}

// export const getNominator = (condition) => {
//     switch(condition) {
//         case 'greater_than': return 'greaterthan';
//         case 'smaller_than': return 'smallerthan';
//         case 'equal_to': return 'equalto';
//         case 'not_equal_to': return 'notequalto';
//         case 'greater_than_or_equal_to': return 'greaterthanorequalto';
//         case 'smaller_than_or_equal_to': return 'smallerthanorequalto';
//         default: return 'undefined'
//     }
// }

export const shippers = [
    'dpd',
    'postnl',
    'dhl',
    'cirro'
]

export const shipperColors = {
    dpd : {
        base: "#DC0032",
        background: "#FDF2F5",
        streamrule: "#FADCE4",
        streamrulehover: "#F6C6D3",
        streamrulevalue: "#FDF2F5",
        streamrulevaluetxtcolor: "#DC0032",
        streamrulevaluehover: "#F6C6D3",
    },
    postnl: {
        base: "#F56900",
        background: "#FFF8F2",
        streamrule: "#FFE9D6",
        streamrulehover: "#FFDBBD",
        streamrulevalue: "#FFF8F2",
        streamrulevaluetxtcolor: "#F56900",
        streamrulevaluehover: "#FFDBBD",
    },
    dhl: {
        base: "#B69100",
        background: "#FFFCF2",
        streamrule: "#FFF6D6",
        streamrulehover: "#FFF0BD",
        streamrulevalue: "#FFFCF2",
        streamrulevaluetxtcolor: "#CDA300",
        streamrulevaluehover: "#FFF0BD",
    },
    bol: {
        base: "#000099",
        background: "#F2F2FA",
        streamrule: "#DADAF0",
        streamrulehover: "#B5B5E2",
        streamrulevalue: "#F2F2FA",
        streamrulevaluetxtcolor: "#000099",
        streamrulevaluehover: "#B5B5E2",
    },
    parcel: {
        base: "#31415f",
        background: "#ecf0f5",
        streamrule: "#ced7e1",
        streamrulehover: "#8E96A7",
        streamrulevalue: "#ecf0f5",
        streamrulevaluetxtcolor: "#31415f",
        streamrulevaluehover: "#8E96A7",
    },
    cirro: {
        base: "#4646f0",
        background: "#F5F5FD",
        streamrule: "#E3E3FA",
        streamrulehover: "#C8C9F7",
        streamrulevalue: "#4646f0",
        streamrulevaluetxtcolor: "#4646f0",
        streamrulevaluehover: "#C8C9F7",
    },
    ups: {
        base: "#B69100",
        background: "#FFFCF2",
        streamrule: "#FFF6D6",
        streamrulehover: "#FFF0BD",
        streamrulevalue: "#FFFCF2",
        streamrulevaluetxtcolor: "#CDA300",
        streamrulevaluehover: "#FFF0BD",
    },
    sendcloud: {
        base: "#1D97FF",
        background: "#F2F9FF",
        streamrule: "#D2EAFF",
        streamrulehover: "#A7D7FF",
        streamrulevalue: "#F2F9FF",
        streamrulevaluetxtcolor: "#F2F9FF",
        streamrulevaluehover: "#A7D7FF",
    },
    trunkrs: {
        base: "#1F0D47",
        background: "#F5F2FA",
        streamrule: "#E1DAF0",
        streamrulehover: "#C3B5E2",
        streamrulevalue: "#F5F2FA",
        streamrulevaluetxtcolor: "#1F0D47",
        streamrulevaluehover: "#C3B5E2",
    },
    innosend: {
        base: "#0D471B",
        background: "#F2FAF4",
        streamrule: "#DAF0DF",
        streamrulehover: "#B5E2BF",
        streamrulevalue: "#F2FAF4",
        streamrulevaluetxtcolor: "#0D471B",
        streamrulevaluehover: "#B5E2BF",
    },
    innosendv2: {
        base: "#0D471B",
        background: "#F2FAF4",
        streamrule: "#DAF0DF",
        streamrulehover: "#B5E2BF",
        streamrulevalue: "#F2FAF4",
        streamrulevaluetxtcolor: "#0D471B",
        streamrulevaluehover: "#B5E2BF",
    },
    zineps: {
        base: "#0D473F",
        background: "#F2FAF9",
        streamrule: "#DAF0ED",
        streamrulehover: "#B5E2DB",
        streamrulevalue: "#F2FAF9",
        streamrulevaluetxtcolor: "#0D473F",
        streamrulevaluehover: "#B5E2DB",
    },
    vinologix: {
        base: "#470D2A",
        background: "#FAF2F6",
        streamrule: "#F0DAE7",
        streamrulehover: "#E2B5CE",
        streamrulevalue: "#FAF2F6",
        streamrulevaluetxtcolor: "#470D2A",
        streamrulevaluehover: "#E2B5CE",
    },
    dhlgermany: {
        base: "#473B0D",
        background: "#FAF8F2",
        streamrule: "#F0ECDA",
        streamrulehover: "#E2D9B5",
        streamrulevalue: "#FAF8F2",
        streamrulevaluetxtcolor: "#473B0D",
        streamrulevaluehover: "#E2D9B5",
    },
    intrapost: {
        base: "#0D1C47",
        background: "#F2F4FA",
        streamrule: "#DADFF0",
        streamrulehover: "#B5C0E2",
        streamrulevalue: "#F2F4FA",
        streamrulevaluetxtcolor: "#0D1C47",
        streamrulevaluehover: "#B5C0E2",
    },
    myparcel: {
        base: "#0D4738",
        background: "#F2FAF8",
        streamrule: "#DAF0EA",
        streamrulehover: "#B5E2D6",
        streamrulevalue: "#F2FAF8",
        streamrulevaluetxtcolor: "#0D4738",
        streamrulevaluehover: "#B5E2D6",
    },
    myparcelcom: {
        base: "#000000",
        background: "#F1F1F1",
        streamrule: "#E5E5E5",
        streamrulehover: "#BFBFBF",
        streamrulevalue: "#F1F1F1",
        streamrulevaluetxtcolor: "#000000",
        streamrulevaluehover: "#BFBFBF",
    },
    gls: {
        base: "#061AB1",
        background: "#F1F2FB",
        streamrule: "#E6E8F7",
        streamrulehover: "#C1C6EB",
        streamrulevalue: "#F1F2FB",
        streamrulevaluetxtcolor: "#061AB1",
        streamrulevaluehover: "#C1C6EB",
    },
    ampere: {
        base: "#00843C",
        background: "#EAF5EF",
        streamrule: "#D9EDE2",
        streamrulehover: "#A6D4BB",
        streamrulevalue: "#EAF5EF",
        streamrulevaluetxtcolor: "#00843C",
        streamrulevaluehover: "#A6D4BB",
    },
    cycloon: {
        base: "#E4002B",
        background: "#FDF1F3",
        streamrule: "#FCE5EA",
        streamrulehover: "#F8BFCA",
        streamrulevalue: "#FDF1F3",
        streamrulevaluetxtcolor: "#E4002B",
        streamrulevaluehover: "#F8BFCA",
    },
    hst: {
        base: "#E42313",
        background: "#FDF3F2",
        streamrule: "#FCE9E7",
        streamrulehover: "#F8C8C4",
        streamrulevalue: "#FDF3F2",
        streamrulevaluetxtcolor: "#E42313",
        streamrulevaluehover: "#F8C8C4",
    },
}

export const getShipperColorSettings = (streamRuleId, shippers) => {
    const shipper = shippers.find(shipper => shipper.id === streamRuleId);
    // console.log("shipper",shipper);
    if (shipper && shipperColors[shipper.type]) {
        return shipperColors[shipper.type];
    }
    return {
        base: "#31415f",
        background: "#ecf0f5",
        streamrule: "#ced7e1",
        streamrulehover: "#8E96A7",
        streamrulevalue: "#ecf0f5",
        streamrulevaluetxtcolor: "#8E96A7",
        streamrulevaluehover: "#8E96A7",
    }; // or a default color setting if needed
}
export const getShipperColorSettingsByType = (shipperType) => {
    return shipperColors[shipperType] ?? {
        base: "#31415f",
        background: "#ecf0f5",
        streamrule: "#ced7e1",
        streamrulehover: "#8E96A7",
        streamrulevalue: "#ecf0f5",
        streamrulevaluetxtcolor: "#8E96A7",
        streamrulevaluehover: "#8E96A7",
    };
}